import Dropzone from '@wielink-application/shared/js/base/dropzone';

// Koppelt de Dropzone class aan een drop-element en file-input. Gedropte of gekozen
// bestanden komen binnen via de onFiles callback; bestanden die niet aan accept
// voldoen gaan naar de onRejected callback.
export function useDropzone({scope, input, accept = null, onFiles, onRejected = null}) {
	new Dropzone({scope: scope, input: input});

	$(scope).on('fileAdded', (event, data) => {
		let files = Array.from(data.files || []);
		let accepted = files.filter((file) => matchesAccept(file, accept));
		let rejected = files.filter((file) => !matchesAccept(file, accept));

		if (rejected.length > 0) {
			onRejected?.(rejected);
		}
		if (accepted.length > 0) {
			onFiles(accepted);
		}
	});
}

// Vergelijkt een bestand met een accept-string zoals die van een file-input,
// bijv. "image/*", ".pdf" of een combinatie: "image/*,.pdf,application/zip".
export function matchesAccept(file, accept) {
	if (!accept) {
		return true;
	}

	let type = (file.type || '').toLowerCase();
	let name = (file.name || '').toLowerCase();

	return accept.split(',')
		.map((pattern) => pattern.trim().toLowerCase())
		.filter((pattern) => pattern.length > 0)
		.some((pattern) => {
			if (pattern.startsWith('.')) {
				return name.endsWith(pattern);
			}
			if (pattern.endsWith('/*')) {
				return type.startsWith(pattern.slice(0, -1));
			}
			return type === pattern;
		});
}

export function convertFileToBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = reject;
	});
}
